"use client";
import Image, { StaticImageData } from "next/image";
import * as images from "@/components/images/Images";
import { cn } from "@/lib/utils";
import { Typography } from "@/components/ui/typography";

type AdvantagesCardProps = {} & React.ComponentProps<"section">;

const LogoImage = ({ src }: { src: StaticImageData }) => (
  <div className="flex justify-center">
    <Image
      alt="logoBlock"
      src={src}
      width={0}
      height={0}
      className="object-contain w-full h-14 lg:h-[76]"
      loading="lazy"
      sizes="(max-width: 768px) 100vw, 33vw"
    />
  </div>
);

export default function LogoTrustBlock({ className }: AdvantagesCardProps) {
  return (
    <section className={cn("section", className)}>
      <div className="py-12 md:py-10.5">
        <div className="container mx-auto grid grid-cols-1 gap-6 lg:gap-12">
          <Typography
            variant="subHeadingLg"
            className="text-gray-800 md:text-center"
            asChild
          >
            <h3>
              Languex is trusted and recognized language excellence for 10,000+
              happy customers
            </h3>
          </Typography>
          <div className="flex flex-wrap md:justify-center gap-8 lg:gap-[min(48px,3.33vw)]">
            {[
              images.logob6_3,
              images.logob6,
              images.logob6_1,
              images.logob6_2,
            ].map((src, index) => (
              <LogoImage key={index} src={src} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
